import { EditIncentivesMarketTermsAndConditionsTemplateModalContextType } from '../types/EditIncentivesMarketTermsAndConditionsTemplateModalContextType';

export const editIncentivesMarketTermsAndConditionsTemplateModalInitValue: EditIncentivesMarketTermsAndConditionsTemplateModalContextType =
  {
    data: {
      societyId: '',
      documentId: null,
      termsText: '',
      isLoading: false,
      isSaving: false,
      loadError: false,
      editorInstance: null,
    },
    actions: {
      handleCloseModal: () => {},
      setTermsText: () => {},
      setEditorInstance: () => {},
      onEditorChange: () => {},
      handleSave: async () => {},
    },
  };
